import http from "../../common/services/httpService";
import {AxiosResponse} from "axios";
import {Api, apiUrls} from "../../helpers/api";
import {TrailerConditionReportModel, SingleTrailerConditionReportModel} from "../models/tcr";
import { HttpErrorModel } from "../../common/models/httpError";

export class TcrService {
    private static baseUrl = apiUrls.tcr.tcr;

    public static async getTcr(orderId: string): Promise<AxiosResponse<TrailerConditionReportModel>> {
        return await http.get(`${Api.getUrl(this.baseUrl)}/${orderId}`);
    }

    public static async modifyTcr(data: SingleTrailerConditionReportModel): Promise<AxiosResponse<HttpErrorModel[] | any>> {
        return await http.post(`${Api.getUrl(this.baseUrl)}`, data);
    }
}